import { Tabs as AntTabs, type TabsProps as AntTabsProps } from 'antd';
import React, { memo } from 'react';

import './Tabs.less';

type TabsProps = Pick<AntTabsProps, 'activeKey' | 'onChange'> & {
  items: NonNullable<AntTabsProps['items']>;
};

/**
 * A wrapper around the antd Tabs with our custom config applied.
 * @see https://www.figma.com/design/Vvl7WmeGXXmS948pRsQNKE/Farmbot-Outback-Design-System?node-id=404-19172
 */
function Tabs(props: TabsProps): JSX.Element {
  return <AntTabs {...props} className="Tabs" />;
}

export default memo(Tabs);
export type { TabsProps };
